import React, { useState } from "react";
import toast from "react-hot-toast";
import InputText from "../ReusableComponents/InputText";
import TextArea from "../ReusableComponents/TextArea";


const BookingCancelPopup = ({ data }) => {
    return (
        <div className="flex justify-center">
            <div className="grid gap-4 mb-2 md:grid-cols-2 w-full md:w-1/2 items-center">
                <InputText
                 title="Booking Id"
                    type="text"
                    name="bookingId"
                    placeholder="Booking ID"
                    className="w-full p-2 mb-3 border rounded"
                    content={data?.booking}
                    disabled={true}
                />

                <InputText
                    inputType="text"
                    title="Guest Name"
                    name="guestname"
                    classStar="text-red-500"
                    content={data?.GuestName || ""}
                    disabled={true}
                />

                <InputText
                 title="Deduction"
                    type="text"
                    name="deduction"
                    placeholder="Deduction"
                    className="w-full p-2 mb-3 border rounded"
                    content={data?.booking}
                    disabled="disabled"
                />

                <InputText
                 title="Contact"
                    type="text"
                    name="contact"
                    placeholder="Contact"
                    className="w-full p-2 mb-3 border rounded"
                    content={data?.booking}
                    disabled="disabled"
                />



                <InputText
                 title="Advance Amount"
                    type="number"
                    name="advanceAmount"
                    placeholder="AdvanceAmount"
                    className="w-full p-2 mb-3 border rounded"
                    content={data?.booking}
                    disabled="disabled"
                />


                <InputText
                 title="Refund Amount"
                    type="text"
                    name="refundAmount"
                    placeholder="Refund Amount"
                    className="w-full p-2 mb-4 border rounded"
                    content={data?.booking}
                    disabled="disabled"
                />
                <div className="col-span-2">
                    <TextArea
                     title="Reason"
                        name="reason"
                        placeholder="Reason for cancellation"
                        className="w-full p-2 mb-3 border rounded"
                        content={data?.booking}
                        disabled="disabled"
                    />
                </div>
            </div>
        </div>
    );
};

export default BookingCancelPopup;
